import React from 'react';
import AppContext from './context';
const useApp = () => React.useContext(AppContext);
export default useApp;


//////////////////
// WEBPACK FOOTER
// ./node_modules/antd/es/app/useApp.js
// module id = 1616
// module chunks = 0